var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRooftent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 90H93V84H99V63H87L84.8775 62.1225L73.7575 51H21V45H75L77.1225 45.8775L88.2425 57H102L105 60V87L102 90Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 81H12V54H27V60H18V75H27V81Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 48H72V22.9825L27 46.805V48H21V45L22.5975 42.3475L73.5975 15.3475L78 18V48Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6601 27.3231L37.6578 45.3202L40.3406 50.687L76.3429 32.6899L73.6601 27.3231Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 97.5C73.71 97.5 69 92.79 69 87C69 81.21 73.71 76.5 79.5 76.5C82.305 76.5 84.9425 77.5925 86.925 79.575C88.9075 81.5575 90 84.195 90 87C90 92.79 85.29 97.5 79.5 97.5ZM79.5 82.5C77.02 82.5 75 84.5175 75 87C75 89.4825 77.02 91.5 79.5 91.5C81.98 91.5 84 89.4825 84 87C84 85.7975 83.5325 84.6675 82.6825 83.8175C81.8325 82.9675 80.7025 82.5 79.5 82.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 97.5C37.71 97.5 33 92.79 33 87C33 81.21 37.71 76.5 43.5 76.5C46.305 76.5 48.9425 77.5925 50.925 79.575C52.9075 81.5575 54 84.195 54 87C54 92.79 49.29 97.5 43.5 97.5ZM43.5 82.5C41.02 82.5 39 84.5175 39 87C39 89.4825 41.02 91.5 43.5 91.5C45.98 91.5 48 89.4825 48 87C48 85.7975 47.5325 84.6675 46.6825 83.8175C45.8325 82.9675 44.7025 82.5 43.5 82.5Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81H57L54 78V72H36V75H30V69L33 66H57L60 69V75H63V69L66 66H90L93 69V75H87V72H69V78L66 81Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 90H24L21 87V51H27V84H30V90Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66 63H57V46.5H63V57H66V63Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooftent);
export default __webpack_public_path__ + "static/media/Rooftent.f4638695.svg";
export { ForwardRef as ReactComponent };